var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Render = function (_a) {
    var children = _a.children, content = _a.content, ifString = _a.ifString, props = _a.props;
    if (children)
        content = children;
    var Content = content;
    var IfString = ifString;
    if (typeof Content === 'string' || typeof Content === 'number')
        return _jsx(IfString, { text: content });
    else if (typeof Content === 'function')
        return _jsx(Content, __assign({}, props));
    else if (React.isValidElement(content))
        return content;
    return null;
};
